import React from "react";

import { templates } from "@reactivated";

// This template is only used by tsi-tempurpedic, which overrides it in
// client/templates/FlagshipInfoTemplate.tsx. Other sites re-export
// this placeholder to satisfy Reactivated's generated imports.
/** @public */
export const Template = (
    _props: templates.FlagshipInfoTemplate,
): React.JSX.Element => {
    return <></>;
};
